import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Segment, Header, List, Grid } from 'semantic-ui-react';
import {
    When,
    Recurrence,
} from '../View/EventDatesInfo';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { Map } from '../';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faBookOpen, faUserGroup, faLink, faEnvelope, faGlobe, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faBookmark, faCalendarDays, faUser } from '@fortawesome/free-regular-svg-icons';

import { Icon } from '../';

const messages = defineMessages({
    what: {
        id: 'event_what',
        defaultMessage: 'What',
    },
    when: {
        id: 'event_when',
        defaultMessage: 'When',
    },
    allDates: {
        id: 'event_alldates',
        defaultMessage: 'All dates',
    },
    where: {
        id: 'event_where',
        defaultMessage: 'Where',
    },
    contactName: {
        id: 'event_contactname',
        defaultMessage: 'Contact Name',
    },
    contactPhone: {
        id: 'event_contactphone',
        defaultMessage: 'Contact Phone',
    },
    attendees: {
        id: 'event_attendees',
        defaultMessage: 'Attendees',
    },
    website: {
        id: 'event_website',
        defaultMessage: 'Website',
    },
    visitWebsite: {
        id: 'visit_external_website',
        defaultMessage: 'Visit external website',
    },
    location: {
        id: 'event_map_location',
        defaultMessage: 'Location',
    },
    address: {
        id: 'event_map_address',
        defaultMessage: 'address'
    },

});

const EventDetails = ({ content, display_as = 'aside' }) => {
    const intl = useIntl();

    const dispatch = useDispatch();

    const getPosition = function (geolocation) {
        if (!geolocation) {
            return null
        }
        return geolocation.split(';').map(parseFloat);
    }

    const geolocation = getPosition(content.geolocation)

    return (
        <>
            <Grid  className="eventDetails py-0" >
                <Grid.Row columns={12} as="dl" className='my-0'>
                    <Grid.Column as="div" mobile={12} tablet={6} computer={4} className="mb-3">
                        <dt className='fw-bold'>{intl.formatMessage(messages.when)}</dt>
                        <dd className="ms-0" >
                            <When
                                start={content.start}
                                end={content.end}
                                whole_day={content.whole_day}
                                open_end={content.open_end}
                            />
                            {content.recurrence && (
                                <div className='eventDetails__field'>
                                    <span className='text-caption'>
                                        {intl.formatMessage(messages.allDates)}
                                    </span>
                                    <div className={'eventDetails__def eventDetails__def--recurrence'}>
                                        <Recurrence recurrence={content.recurrence} start={content.start} />
                                    </div>
                                </div>
                            )}
                        </dd>
                    </Grid.Column>
                    {content.contact_name && (
                    <Grid.Column as="div" mobile={12} tablet={6} computer={4} className="mb-3">
                        <dt className='fw-bold'>{intl.formatMessage(messages.contactName)}</dt>
                        <dd className="ms-0">
                            {content.contact_email ? (
                                <a href={`mailto:${content.contact_email}`}>
                                    {content.contact_name}
                                </a>
                            ) : (
                                content.contact_name
                            )}
                        </dd>
                    </Grid.Column>
                    )}
                    {content.contact_phone && (
                    <Grid.Column as="div" mobile={12} tablet={6} computer={4} className="mb-3">
                        <dt className='fw-bold'>{intl.formatMessage(messages.contactPhone)}</dt>
                        <dd className="ms-0">
                            <a href={'tel:+34' + content.contact_phone.replace(/ /g, '')}>{content.contact_phone}</a>
                        </dd>
                    </Grid.Column>
                    )}
                    {content.location && (
                        <Grid.Column as="div" mobile={12} tablet={6} computer={4} className="mb-3">
                            <dt className='fw-bold'>{intl.formatMessage(messages.where)}</dt>
                            <dd className="ms-0">
                                {content.location}
                            </dd>
                        </Grid.Column>
                    )}
                    {content.event_url && (
                        <Grid.Column as="div" mobile={12} tablet={6} computer={4} className="mb-3">
                            <dt className='fw-bold'>{intl.formatMessage(messages.website)}</dt>
                            <dd className="ms-0">
                                <a href={content.event_url}>{intl.formatMessage(messages.visitWebsite)}</a>
                            </dd>
                        </Grid.Column>
                    )}
                    {content.subjects?.length > 0 && (
                        <Grid.Column as="div" mobile={12} tablet={6} computer={4} className="mb-3">
                            <dt className='fw-bold'>{intl.formatMessage(messages.what)}</dt>
                            <dd className="ms-0">
                                <ul>
                                    {content.subjects.map((subject, index) => (
                                        <li key={index}>{subject}</li>
                                    ))}
                                </ul>
                            </dd>
                        </Grid.Column>
                    )}
                    {content.attendees?.length > 0 && (
                        <Grid.Column as="div" mobile={12} tablet={6} computer={4} className="mb-3">
                            <dt className='fw-bold'>{intl.formatMessage(messages.attendees)}</dt>
                            <dd className="ms-0">
                                <ul>
                                    {content.attendees.map((subject, index) => (
                                        <li key={index}>{subject}</li>
                                    ))}
                                </ul>
                            </dd>
                        </Grid.Column>
                    )} 
                </Grid.Row>
                {geolocation && (
                <Grid.Row columns={1}>
                    <Grid.Column>
                        <span className='fw-bold'>{intl.formatMessage(messages.location)}</span>
                        <Map marker={geolocation} center={geolocation} />
                    </Grid.Column>
                </Grid.Row>
                )}
            </Grid>

        </>
    );
};

export default EventDetails;
